import { RootState, useSelector } from "redux/store";
import { useTheme } from "@mui/material/styles";
import createAvatar from "utils/createAvatar";
import { CustomTheme } from "enums/customTheme";
import Avatar, { Props as AvatarProps } from "./Avatar";

export default function MyAvatar({
  user,
  ...other
}: AvatarProps & { user?: any }) {
  const theme = useTheme();
  const customTheme = useSelector(
    (state: RootState) => state.supplier?.supplier?.customTheme,
  );
  // const customTheme = "Volotea";

  const getCustomColor = () => {
    if (customTheme === CustomTheme.Sage) return theme.palette.sage_green;
    if (customTheme === CustomTheme.Volotea)
      return theme.palette.volotea?.red || "default";
    if (user?.photoURL) return "default";
    return theme.palette.primary.main;
  };

  return (
    <Avatar
      src={user?.photoURL}
      alt={user?.name}
      customColor={getCustomColor()}
      {...other}
      sx={
        customTheme === CustomTheme.Sage || customTheme === CustomTheme.Volotea
          ? { color: theme.palette.common.white }
          : undefined
      }
    >
      {createAvatar(user?.name).name}
    </Avatar>
  );
}
